import {useState} from 'react';
import Field from '../Field';

type PasswordFieldProps = {
    label: string;
    placeholder: string;
    isRequired: boolean;
    name: string;
    classNames?: string;
    value: string;
    onChange: Function;
    onFocus?: Function;
    error?: string | Function | boolean;
    success?: boolean;
}

export const PasswordField = ({
    label,
    placeholder,
    name,
    isRequired,
    value,
    classNames = '',
    onChange,
    onFocus = null,
    error,
    success,
}: PasswordFieldProps) => {
    const [inputType, setInputType] = useState<string>('password');
    const [appendType, setAppendType] = useState<string>('eye');
    
    function handleInputType() {
        setInputType(inputType === 'password' ? 'text' : 'password')
        setAppendType(inputType === 'password' ? 'eye-slash' : 'eye')
    }

    return (
        <Field
            label={label}
            placeholder={placeholder}
            labelRequired={isRequired}
            name={name}
            classNames={classNames}
            value={value}
            onChange={onChange}
            onFocus={onFocus}
            toggleAdornment={handleInputType}
            error={error}
            append={appendType}
            type={inputType}
            success={success}
        />
    )
}
